import { AppGridLayout } from 'api'

export const GridDemoData = {
	defaultViewId: 2,
	appGridSearch: {
		projectFilter: true,
		projectFilterField: 'projectId',
		projectFilterKeyName: 'projectId',
		projectFilterType: 1,
		projectFilterLabel: '项目',
		appGridCommonSearch: {
			appGridCommonSearchItemList: [
				{ dataType: 'string', field: 'test', label: 'hah' },
				{ dataType: 'string', field: 'test2', label: 'hah3' },
			],
		},
		appGridAdvancedSearch: {
			labelWidth: 110,
			appGridAdvancedSearchItemList: [
				{
					keyName: 'a1',
					type: 'text',
					field: 'a1',
					label: '面积变更id',
					dataType: 'text',
				},
			],
		},
	},
	appGridHeard: {
		appGridTabs: {
			appGridTabList: [
				{ title: '未审核', viewId: 1 },
				{ title: '审核中', viewId: 2 },
				{ title: '已审核', viewId: 3 },
				{ title: '全部', viewId: 4 },
			],
		},
		appGridMenu: {
			appActionList: [
				// { title: "新增", type: "primary" }
			],
		},
	},
	appGridViewList: [
		{
			viewId: 1,
			appTable: {
				apiPath: 'api/modeling/entity/getPageList',
				type: 'apiPath',
				showIndexColumn: true,
				paging: true,
				appTableColAction: {
					tableActionList: [
						{
							actionCode: '66931201',
							label: '复制',
						},
					],
				},
				appTableColList: [
					{ title: '中文名', width: 200, field: 'displayName' },
					{ title: '英文名', width: 200, field: 'name' },
					{ title: '状态', width: 100, field: 'state' },
					{ title: '修改人', width: 200, field: 'modifiedBy' },
					{ title: '修改时间', width: 150, field: 'modifiedOn' },
				],
			},
		},
		{
			viewId: 2,
			appTable: {
				apiPath: 'api/modeling/entity/getPageList',
				type: 'apiPath',
				showIndexColumn: true,
				tableActionList: [
					{
						actionCode: '66931201',
						title: '复制',
					},
				],
				appTableColList: [
					{ title: '中文名', width: 200, field: 'displayName' },
					{ title: '英文名', width: 200, field: 'name' },
					{ title: '状态', width: 100, field: 'state' },
					{ title: '修改人', width: 200, field: 'modifiedBy' },
					{ title: '修改时间', width: 150, field: 'modifiedOn' },
				],
			},
		},
	],
} as AppGridLayout



// WEBPACK FOOTER //
// ./src/modules/modeling/page/GridDemoData.tsx